<template>
  <div v-if="dataNotNull" key="1" class="safetyDiv" style="width: 100%; height: 100%">
    <div class="container1" style="margin:15px 0 0 25px;height: 100%;"></div>
  </div>
  <div v-else key="2" style="width: 100%; height: 100%;">
    <div class="title_safety">Monthly WSH Inspection <br/>(Top 5 Findings by Type)
    </div>
    <div class="zero_safety">No Data !</div>
  </div>
</template>

<script>
import echarts from 'echarts'
import axios from 'axios'

export default {
  name: "safety",
  data() {
    return {
      color: this.$store.state.color.chart_color,
      myChart: null,
      name: "safety",
      dataNotNull: true
    }
  },
  methods: {
    init() {
      // this.$root.charts.push(this.myChart)
      window.addEventListener("resize", function () {
        this.myChart.resize()
      }.bind(this))
    },

    analysisResult(result) {
      var legends = []
      var equipments = []
      var assists = []
      var totle = []
      var total = 0
      var assist = 0

      for (var i in result) {
        var type = result[i].type
        var count = result[i].count
        legends.push(type.substring(0, 18))
        equipments.push({name: type.substring(0, 18), value: count})
        total += parseInt(count)
      }
      total *= 0.7
      assist = total / 8
      for (var i in result) {
        var type = result[i].type
        var count = parseInt(result[i].count) + assist
        assists.push({name: type.substring(0, 18), value: count})
        totle.push({name: type.substring(0, 18), value: total})
      }
      return {legends: legends, equipments: equipments, assists: assists, totle: totle, assist: assist}
    },

    //获取当前月的第一天
    getFirstDate() {
      //当月第一天例2019-05-01
      var date = new Date();
      date.setDate(1);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      var d = date.getDate();
      m = m < 10 ? "0" + m : m;
      d = d < 10 ? "0" + d : d;
      return y + "-" + m + "-" + d;
    },

    //获取当前月的最后一天
    getLastDate() {
      //当月最后一天例2019-05-31
      var date2 = new Date();
      var currentMonth = date2.getMonth();
      var nextMonth = ++currentMonth;
      var nextMonthFirstDay = new Date(date2.getFullYear(), nextMonth, 1);
      var oneDay = 1000 * 60 * 60 * 24;
      Date(nextMonthFirstDay - oneDay);
      var y2 = date2.getFullYear();
      var m2 = date2.getMonth() + 1;
      var d2 = date2.getDate();
      m2 = m2 < 10 ? "0" + m2 : m2;
      d2 = d2 < 10 ? "0" + d2 : d2;
      return y2 + "-" + m2 + "-" + d2;
    },
  },
  beforeDestroy() {
    if (this.myChart) {
      this.myChart.clear()
    }
  },

  mounted() {
    let that = this
    this.myChart = echarts.init(document.querySelector('.safetyDiv .container1'))
    this.myChart.setOption({
      title: {
        text: "Monthly WSH Inspection\n" + "(Top 5 Findings by Type)",
        textStyle: {
          color: '#FFF',
          fontSize: 16
        }
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'none'
        },
        formatter: function (params) {
          return params[1].name + ':  ' + Math.round(params[2].value * 70 / params[0].value) + '%';
        }
      },
      grid: {
        left: 130
      },
      xAxis: {
        type: 'value',
        show: false,
        axisLabel: {
          formatter: '{value}'
        }
      },
      yAxis: {
        type: 'category',
        inverse: true,
        data: [],
        axisLine: {
          show: true,
          lineStyle: {
            color: '#6CF'
          }
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          margin: 15,
          align: 'right',
          show: true,
          textStyle: {
            color: '#FFF',
          }
        },
        splitLine: {
          show: false
        }
      },
      series: [
        {
          name: '总计',
          type: 'bar',
          barGap: '-100%',
          barWidth: '60%',
          label: {
            normal: {
              show: false,
              color: '#6cf',
              position: 'insideRight',
            }
          },
          itemStyle: {
            normal: {
              color: '#00000000',
              borderColor: '#999',
              borderWidth: '0',
            }
          },
          data: []
        },
        {
          name: '总计',
          type: 'bar',
          barGap: '-100%',
          barWidth: '60%',
          label: {
            normal: {
              show: true,
              color: '#6cf',
              position: 'insideRight',
              formatter: '{c}'
            }
          },
          itemStyle: {
            normal: {
              color: '#00000000',
            }
          },
          data: []
        },
        {
          name: '申请',
          type: 'bar',
          barWidth: '60%',
          data: [],
          label: {
            normal: {
              show: false,
              formatter: '{b}'
            }
          },
          itemStyle: {
            normal: {
              color: function (params) {
                return that.color[params.dataIndex]
              },
            }
          },
        }
      ]
    })

    this.myChart.showLoading({
      text: '',
      color: '#66CCFF',
      maskColor: 'rgba(255, 255, 255, 0)',
    });

    let postData = {
      cms_conid: window.localStorage.getItem('cons_id'),
      start_date: this.getFirstDate(),
      // start_date: '2020-12-01',
      end_date: this.getLastDate(),
      user: window.localStorage.getItem("token_key"),
      token: window.localStorage.getItem('token')
    }
    axios.post(this.$store.getters.getCmsServer + "DBConCheckType", postData).then(resp => {
      var errNo = resp.data.errno
      var errStr = resp.data.errstr_cn
      this.myChart.hideLoading()
      if (errNo == "0") {
        this.dataNotNull = true
        var legends = []
        var safetys = []
        var result = resp.data.result;
        var data = this.analysisResult(result)
        this.myChart.setOption({
          yAxis: {
            data: data.legends,
          },
          series: [
            {
              data: data.totle
            },
            {
              data: data.assists,
              label: {
                normal: {
                  show: true,
                  color: '#6cf',
                  position: 'insideRight',
                  formatter: function (params) {
                    return parseInt(params.value) - parseInt(data.assist);
                  }
                }
              },
            },
            {
              data: data.equipments
            }
          ]
        })
      } else {
        this.dataNotNull = false
      }
    }).catch(error => {
      alert("DBConCheckType.error:" + error)
      this.dataNotNull = false
      this.myChart.hideLoading()
    })
  }
}
</script>

<style lang="stylus" scoped>
.title_safety
  width 100%
  height 10%
  text-align left
  font-weight bold
  font-size 16px
  color #FFF
  padding-top 17px
  padding-left 30px

.zero_safety
  width 100%
  height 100%
  text-align center
  padding-top 15%
  font-size 28px
  color #6CF
</style>



// WEBPACK FOOTER //
// src/components/constractor/safety.vue